"use client";

import { useEffect } from "react";

export default function HotLeagueTabs({
  leagues = [],
  activeLeagueId,
  onChange,
  autoSelectFirst = true,
}) {
  useEffect(() => {
    if (autoSelectFirst && leagues?.length) {
      onChange?.(leagues[0]);
    }
  }, [leagues]);
  return (
    <div className="w-full overflow-x-auto md:overflow-visible">
      <div
        className="
          flex gap-2 p-2
          whitespace-nowrap md:whitespace-normal
          flex-nowrap md:flex-wrap
        "
      >
        {leagues.map((league) => {
          const isActive = league.id === activeLeagueId;

          return (
            <button
              key={league.id}
              onClick={() => onChange?.(league)}
              className={`
    px-3 py-1.5 rounded-full text-sm transition
    ${
      isActive
        ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)] font-semibold"
        : "bg-[var(--theme-bg)] text-[var(--theme-text)] font-medium"
    }
  `}
            >
              {league.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
